module.exports = __webpack_public_path__ + "img/moon-over-sun.57d6db51.svg";